export default Object.freeze({

    //e-invoice
    MSIC_LIST:'api/List/msic',
    EINVOICE_SUBMIT:'api/account/corporate/additionalinformation',
    ADDITIONAL_INFO_INIT:'api/account/corporate/additionalinformation/init',
    //e-nvoice end
    //transaction folder api starts
    RECEIPT_REQUEST: 'api/StaffExpense/requestReceipt',
    STAFF_EXPENSE_LIST: 'api/staffExpense/staffExpenseInit',
    STAFF_EXPENSE_DETAILS: 'api/StaffExpense/get/${id}',
    APPROVE_RECEIPT_REQUEST: 'api/StaffExpense/approveReRequestReceipt',
    STAFF_EXPENSE_STATUS: 'api/List/listStaffExpenseStatus',
    STAFF_TRANACTION_TYPE: 'api/List/ListTransactionType',
    STAFF_ADMIN_LIST: 'api/topup/admin/list',
    STAFF_EXCEL: '/api/StaffExpense/export/excel',
    ALLTRANSACTION_EXCEL : '/api/transaction/alltransaction/export/excel',
    ADMINTRANSACTION_EXCEL : 'api/transaction/admintransaction/export/excel',
    //transaction folder api ends

    //Transaction api starts
    ADMIN_TRANSACTION: 'api/Transaction/admintransactions',
    ALL_TRANSACTION: 'api/Transaction/alltransaction',
    MASTER_WALLET_TOPUP_STATUS: 'api/list/listMasterWalletTopupStatusCorporateBO',
    BULK_TOPUP_STATUS: 'api/List/topupstatus',
    STAFF_EXPENSE_FILTER: 'api/Test/staffexpenses?limit=',
    GET_TEST: 'api/Test/list?page=0&limit=10',
    POST_TEST: 'api/Test/list',
    STAFF_TOPUP_REQUEST: 'api/Test/stafftopuprequest?limit=',
    STAFF_TOPUP_REQUEST_FILTER: 'api/List/status-filter',
    //Transaction api end


    //Login Api starts
    KILLSWITCH_ACTIVATE:"api/account/killswitch",
    DELETE_ACCOUNT:'api/account/delete',
    GET_BANNERDETAILS:'api/Banner/carousellist',
    LOGIN: 'api/account/corporate/login',
    SENDOTP: 'api/account/corporate/send/otp',
    RESEND_OTP: 'api/otp/resend',
    RESET_EMAIL: 'api/account/sendresetemail',
    SIGN_OUT: 'api/account/corporate/logout',
    VERIFY: 'api/account/corporate/registration/verify',
    CHANGEPASSWORD: 'api/account/changepassword',
    CORPORATE_DETAILS: 'api/account/corporate/corporatedetails',
    RESET_PASSWORD: 'api/account/resetpassword',
    ADD_CONSENT:'/api/account/consent',
    LIST_CONSENT:'/api/List/consentinit',
    GENERATE_SDK_TOKEN_DIRECTOR: 'api/Onfido/director/generate_sdk_token',
    GENERATE_SDK_TOKEN_ADMIN: 'api/Onfido/generate_sdk_token',
    ONFIDO_PROCESS_DIRECTOR: 'api/Onfido/director/process',
    ONFIDO_PROCESS_ADMIN: 'api/Onfido/process',
    ONFIDO_PROCESS_CHECK: 'api/Onfido/check',


    //Login Api ends


    //RegisterService APi starts
    RPP_VALIDATION:'api/account/corporate/bankvalidation',
    BUSSINESS_DETAILS: 'api/account/corporate/businessDetails',
    ADDRESS_DETAILS: 'api/account/corporate/addressdetails',
    CREATE_USER: 'api/account/corporate/createuser',
    ADD_DIRECTOR: 'api/account/corporate/directordetails',
    ADD_SHAREHOLDER: 'api/account/corporate/shareholderdetails',
    COMPANY_RELATIONSHIP: 'api/List/companyrelationship',
    POST_CODE: 'api/getaddress/postcode/${id}',
    FORM_LIST: 'api/account/corporate/formlist',
    DUE_DILIGENCE: 'api/account/corporate/duediligence',
    DRAFT_DUEDILLIGENCE:'api/account/corporate/duediligencedraft',
    OFFLINE_CONSENT: 'api/account/corporate/offlineconsent',
    ONLINE_CONSENT: 'api/account/corporate/sendonlineconsent',
    VERIFY_CONSENT: 'api/account/corporate/verifyonlineconsent',
    ADDADMIN_DETAILS:'api/account/corporate/admindetails',
    ADDCORP_DETAILS:'api/account/corporate/corpdetail',
    AML_SCREENING: '/api/account/corporate/screenindividual',
    //RegisterService APi ends


    //CLAIMS API starts
    GET_DASHBOARD_DURATION:'api/List/duration',
    CLAIM_GRAPH:'api/Claim/dashboard/graph',
    CLAIMLIST: 'api/Claim/request/list',
    CLAIMREJECT: 'api/Claim/request/reject',
    CLAIMAPPROVE: 'api/Claim/request/approve',
    CLAIMREIMBURSE: '/api/Claim/request/reimburse?id=${id}',
    GET_CLAIM: 'api/Test/claimspaginatedfilter?page=0&limit=10',
    CLAIM_FILTERED: 'api/Test/claimspaginatedfilter',
    CLAIM_SUBSCRIBE:'api/Claim/activate',
    CLAIM_SUBSCRIPTION_TYPES:'api/List/subscriptiontype',
    CLAIMSTATUSLIST:'api/List/claimstatus',
    CLAIMFILTERLIST:'api/List/claimtypefilter',
    CLAIMEXCEL:'api/claim/request/export/excel',
    CLAIM_SUBSCRIPTION_CANCEL: 'api/List/claimsubscriptioncancelreason',
    CLAIM_MANAGE_SUBSCRIPTION: 'api/Subscription/claim/init',
    CLAIM_UPDATE_REPORT: '/api/Claim/subscription/customfield/update',

    //subscriptionflow
    CLAIM_RENEW:'api/Claim/subscription/renew',
    INIT_CLAIM_SUBSCRIPTION:'api/Claim/subscription/init',
    CUSTOMFIELD_INIT:'api/Claim/subscription/customfield/init',
    CUSTOMFIELD_TYPE:'api/List/customfieldtype',
    REPORT_PREVIEW:'api/Claim/subscription/receipt/preview',
    CLAIM_DASHBOARD_MONTHDETAIL:'api/Claim/request/claimmonthdetail',
    CLAIM_SUBSCRIBE_ACTIVATE:'api/Claim/subscription/activate',
    CLAIM_SUBSCRIBE_DEACTIVATE: 'api/Claim/subscription/deactivate',
    CLAIM_SUBSCRIBE_APPROVE: '/api/Claim/subscription/pending/approve',
    CLAIM_PENDING_REJECT: '/api/Claim/subscription/pending/reject',
    CLAIM_CANCEL_REQUEST: '/api/Claim/subscription/pending/cancel',
    CLAIM_SUBSCRIBE_UPGRADE:'/api/Claim/subscription/plan/upgrade',
    CLAIM_PLAN_UPGRADE_CANCEL_REASON:'/api/List/claimdeactivationreason',
    CLAIM_PLAN_REQ_CANCEL:'api/Claim/subscription/upgrade/cancel',
    CLAIM_PLAN_REQ_REJECT:'api/Claim/subscription/upgrade/reject',
    CLAIM_PLAN_REQ_APPROVE:'api/Claim/subscription/upgrade/approve',

    //claimtype and subtypes
    CLAIMTYPES_INIT:'api/Claim/claimtype/init',
    CLAIMTYPE_ADDUPDATE:'api/Claim/claimtype/add',
    TRAVELLING_UPDATE:'api/Claim/claimtype/updatetravelling',
    //CLAIMS API ends


    //MANAGE CARD API's starts
    WITHDRAW_REQUEST:'api/TopUp/cardtowallet/add',
    WITHDRAW_APPROVE:'api/TopUp/cardtowallet/approve',
    WITHDRAW_REJECT:'api/TopUp/cardtowallet/reject',
    RELEASE_INITIALTOPUP:'api/TopUp/initial/release',
    MANAGE_CARD_LIST: 'api/Card/cardholders/list',
    MANAGE_CARD_ADD: 'api/Card/cardholders/add',
    MANAGE_CARD_EDIT: 'api/Card/edit',
    MANAGE_CARD_EDIT_BANK: 'api/account/claim/bankvalidation',
    BLOCK_CARD: 'api/Card/block',
    UNBLOCK_CARD: 'api/Card/unblock/request',
    BLOCK_MULTIPLE_CARD: 'api/Card/blockmultiple',
    DEACTIVATE_CARD: 'api/Card/deactivate',
    DEACTIVATE_MULTIPLE_CARD: 'api/Card/deactivatemultiple',
    GETFEES: 'api/Card/getfee',
    GET_CARD_SERVICES: 'api/Card/getcardservice',
    CARD_BALANCE_USER: "api/Dashboard/cardbalancebyuser",
    GETCARDBYID: 'api/Card/getbyid?id=${id}',
    GETEDITEDCARDBYID:'/api/Card/getbyeditedid?id=${id}',
    GETFPXCONFIRM: 'api/Fpx/confirmation',
    BULK_UPLOAD: 'api/Card/bulkupload',
    BULKTOPUP_UPLOAD: 'api/TopUp/bulktopup/excel/upload',
    DOWNLOAD_SAMPLE: 'api/Card/sampleexcel',
    DOWNLOAD_BULKTOPUP_SAMPLE: '/api/TopUp/bulktopup/excel',
    DEACTIVATE_REQUEST_APPROVE: 'api/Card/deactiverequest/approve',
    DEACTIVATE_REQUEST_REJECT: 'api/Card/deactiverequest/reject',
    BLOCK_REQUEST_APPROVE: 'api/Card/blockrequest/approve',
    BLOCK_REQUEST_REJECT: 'api/Card/blockrequest/reject',
    UNBLOCK_REQUEST_APPROVE: 'api/Card/unblock/approve',
    UNBLOCK_REQUEST_REJECT: 'api/Card/unblock/reject',
    INITIAL_INITFILTER: 'api/Card/initfilter',
    CLAIMS_ADD: 'api/Card/addclaimdetails',
    CARD_ADD_REJECT: 'api/Card/admin/reject',
    CARD_ADD_APPROVE: 'api/Card/admin/approve',
    CARD_EDIT_APPROVE: 'api/Card/edit/approve',
    CARD_EDIT_REJECT:'api/Card/edit/reject',
    RECURRING_STANDING_TOPUP_LIST: '/api/TopUp/standingtopup/list',
    RECURRING_STANDING_TOPUP_FREQUENCY: '/api/List/standingtopupfrequency',
    RECURRING_STANDING_TOPUP_ACTIVECARDS: '/api/Card/getactivecards',
    RECURRING_STANDING_TOPUP_HISTORY_LIST: '/api/TopUp/standingtopupexecutionhistory/list',
    RECURRING_STANDING_TOPUP_CREATE:'/api/TopUp/addstandingtopupinstruction',
    RECURRING_STANDING_TOPUP_APPROVE:'/api/TopUp/standinginstruction/approve',
    RECURRING_STANDING_TOPUP_REJECT:'/api/TopUp/standinginstruction/reject',
    RECURRING_STANDING_TOPUP_DELETE:'/api/TopUp/standinginstruction/delete',
    RECURRING_STANDING_TOPUP_EDIT_GET:'/api/TopUp/standinginstruction/compareedit',
    RECURRING_STANDING_TOPUP_EDIT_APPROVE:'/api/TopUp/standinginstruction/approveedit',
    RECURRING_STANDING_TOPUP_EDIT_REJECT:'/api/TopUp/standinginstruction/rejectedit',
    RECURRING_STANDING_TOPUP_EDIT_POST:'/api/TopUp/standinginstruction/edit',
    MCW_BALANCE: '/api/MultiCurrency/mcwbalance',

    //MANAGE CARD API's End

    //LIST API's starts
    LISTNATIONAlITY: 'api/List/nationality',
    LISTBLOCKREASON: 'api/List/blockreason',
    LISTCARDSTATUS: 'api/List/cardstatus',
    LISTCARDFUNCTION: 'api/List/cardfunction',
    LISTCARDTYPE: 'api/List/cardtype',
    LISTCLOSEDREASON: 'api/List/closedreason',
    LISTIDTYPE: 'api/List/idType/${id}',
    ALLLISTIDTYPE:'api/List/idtype',
    LIST_WALLET_SIZE: 'api/List/walletsize',
    REGISTRATION_DATA: 'api/List/corporate/registrationdata',
    REGISTRATION_DATA_DIRECTOR: 'api/List/registrationdata',
    BANK_LIST:'/api/List/banks',
    //LIST API's ends
    //Views/config/claims API starts
    BANK_CLAIMS_LIST: "/api/List/claim-banks",
    //Views/config/claims API starts
    //getConfigurations Api starts
    GET_CONFIGURATIONS: 'api/Test/configuration',
    //getConfigurations Api end

    //Announcement Api starts
    ANNOUNCEMENT_GRIDURL: 'api/Announcement/list',
    ANNOUNCEMENT_DELETEURL: 'api/Announcement/delete',
    ANNOUNCEMENT_ADDURL: 'api/Announcement/Add',
    GET_ANNOUNCEMENT_TYPE: '/api/List/announcementtype',
    GET_USERLIST: 'api/Announcement/userlist',
    GET_CHANNEL_LIST: 'api/List/channel',
    ON_FILE_CHANGE: 'api/Upload/upload',
    //Announcement Api end

    //manage-account Api starts
    BANK_DETAILS:'api/TopUp/masterwallet/loadmoney/bankdetail',
    MASTER_ACCOUNT_ADDURL: 'api/TopUp/masterwallet/loadmoney',
    MASTER_WALLET_GRIDURL: 'api/TopUp/masterwallet/pendinglist',
    MASTER_WALLET_APPROVE: 'api/TopUp/coadmin/masterwallet/approve',
    MASTER_WALLET_REJECT: 'api/TopUp/coadmin/masterwallet/reject',
    FPX_PROVIDER: 'api/Fpx/providers',
    WALLETSOURCE: 'api/List/wallettopupsource',
    YEARLY_TOPUP_SUMMARY: 'api/Dashboard/masterwallettopupyearly',
    DAILY_TOPUP_SUMMARY: 'api/Dashboard/masterwallettopupmonthlyweekly',
    SPENDING_SUMMARY:'api/Dashboard/getTopSpenderForCorporate',
    DASHBOARD_CARD:'api/Dashboard/getcard',
    //manage-account Api ends

    //transaction/staff-topup Api starts
    TopUp_APPROVE: 'api/TopUp/approve',
    TopUp_REJECT: 'api/TopUp/reject',
    INITIAL_TOPUP: 'api/TopUp/initial',
    BULK_REQUEST: 'api/TopUp/bulkrequest',
    SINGLE_TOPUP: 'api/TopUp/singletopup',
    BULK_TOPUP:'api/TopUp/bulktopup',
    GET_MASTER_BALANCE:'/api/TopUp/corporatebalance',
    //transaction/staff-topup Api ends

    //bulktopupapprove api starts
    BULK_APPROVAL_LIST:'api/topup/bulktopuprequest/list',
    BULK_APPROVAL_GETBYID:'api/TopUp/bulktopuprequest/init',
    APPROVE_BULK:'api/topup/bulktopuprequest/approve',
    REJECT_BULK:'api/topup/bulktopuprequest/reject',

    //settings Api starts
    GET_BY_APPROVAL: 'api/Configuration/approvalLevel/getByCorporateApprovalLevel',
    GET_APPROVAL_ID: 'api/Configuration/approvalLevel/getByCorporateApprovalLevel/${id}',
    GET_APPROVAL_UPDATED: 'api/Configuration/approvalLevel/updateApprovalLevel',
    GET_CORP_MASTERACC_LIMIT:'/api/Configuration/corporatemasteraccountlimit/get/',
    //settings Api ends

    //usermangement/managerole Api starts
    UAMFORM_UPLOAD:'api/UserManagement/adduamform',
    ROLE_LIST: 'api/Role/corporatebo/list',
    ROLE_ACTION: 'api/Role/corporatebo/roleaction',
    ROLE_INIT: 'api/Role/corporatebo/init',
    ROLE_UPDATE: 'api/Role/corporatebo/update',
    ROLE_DELETE:'api/Role/Delete',
    //usermangement/managerole Api ends

    //usermangement/manageuser Api starts
    GETUSER_BYID:'api/UserManagement/corporatebo/getuserbyid/${id}',
    USER_LIST: 'api/UserManagement/corporatebo/listuser',
    USER_ADD: 'api/UserManagement/corporatebo/adduser',
    USER_UPDATE: 'api/UserManagement/corporatebo/edituser',
    USER_DELETE: 'api/UserManagement/corporatebo/delete/${id}',
    LIST_ROLE: 'api/UserManagement/corporatebo/init',
    USER_INIT: 'api/UserManagement/corporatebo/init/${id}',
    USER_INITLIST :'api/UserManagement/corporatebo/inituser',
    USER_APPROVE:'/api/UserManagement/corporatebo/approvepending',
    //usermangement/manageuser Api ends


    //DASHBOARD Api starts
    ADMIN_DETAILS: 'api/Dashboard/admin/details',
    SSM_EXPIRED:'api/SSMDetail/corporatebo/save',
    CORPORATE_BALANCE: 'api/Dashboard/corporatebalancesummary',
    TRANSACTION: 'api/test/transactions/list',
    EXPENSE_OVERVIEW_DETAILS: 'api/Dashboard/expenseoverviewdetail',
    YEARLY_EXPENSE_OVERVIEW: 'api/Dashboard/yearlyexpenseoverview',
    DAILY_EXPENSE_OVERVIEW: 'api/Dashboard/dailyexpenseoverview',
    PACKAGE_RENEW_PROMPT:'api/Dashboard/updatepackagenotification',
    CLAIM_RENEW_PROMPT:'api/Dashboard/updateclaimnotification',
    POPUP_VIEWED: '/api/TopUp/standinginstruction/promptviewed',
    GET_MESSAGE_ALERT: '/api/Dashboard/getMessageAlert',
    CLOSE_MESSAGE_ALERT: '/api/Dashboard/closeMessageAlert',
    //DASHBOARD Api ends

    //NOTIFICATION API STARTS
    NOTIFY: 'api/Notification/list',
    UPDATE_VIEW_NOTIFICATION: 'api/Notification/updateviewednotification',
    REMINDER_LIST: 'api/Reminder/list',
    ADD_REMINDER: 'api/Reminder/add',
    REMINDER_BY_ID: 'api/Reminder/getbyid?id=${id}',
    DELETE_REMINDER: 'api/Reminder/delete/',
    REMINDER_TYPE: 'api/List/remindertype',
    REMINDER_FREQUENCY: 'api/List/reminderfrequency',
    LIST_CHANNEL: 'api/List/channel',
    //NOTIFICATION API END



    //userListService api starts
    ASSIGNED_USER: 'api/Test/assigneduser',
    UNASSIGNED_USER: 'api/Test/unassigneduser',
    //userListService api ends


    //Report Api starts
    REPORT_CLAIMS: 'api/Report/claim',
    REPORT_SECONDARYNO: 'api/Report/secondarynumber/detail',
    REPORT_TRANSACTION: 'api/Report/total/transaction',
    REPORT_PREFUND_BALANCE: 'api/Report/total/prefundbalance',
    REPORT_EKYC_REGISTRATION: 'api/Report/ekyc/registration',
    REPORT_MFA_ACTIVATION: 'api/Report/mfa/activation',
    REPORT_MFA_TRANSACTION: 'api/Report/mfa/transaction',
    REPORT_COMPANY_ONBOARDING: 'api/Report/company/onboardingdetail',
    //Report Api ends

    // Estatement Api starts
    CARDHOLDER_ESTATEMENT_EXISTS: '/api/Transaction/bo/cardwork/statementexists',
    CARDHOLDER_ESTATEMENT: '/api/Transaction/bo/cardwork/statement',
    CORPORATE_ESTATEMENT_EXISTS: '/api/Transaction/bo/corporate/statementexists',
    CORPORATE_ESTATEMENT: '/api/Transaction/bo/corporate/statement',
    // Estatemant Api ends

    //package-subscription starts
    PACKAGE_SUBSCRIPTION_INIT:'api/Subscription/package/init',
    PACKAGE_SUBSCRIPTION_POST:'api/account/corporate/subscriptionpackage',
    PACKAGE_SUBSCRIPTION_UPGRADE:'api/Subscription/package/upgrade',
    PACKAGE_SUBSCRIPTION_APPROVE:'api/Subscription/package/pending/approve',
    PACKAGE_SUBSCRIPTION_REJECT:'api/Subscription/package/pending/reject',
    PACKAGE_SUBSCRIPTION_CANCEL:'api/Subscription/package/pending/cancel',
    PACKAGE_SUBSCRIPTION_RENEW:'api/Subscription/package/renew',
    PACKAGE_SUBSCRIPTION_CREATE_EXISTING:'api/Subscription/package/existing',
    PACKAGE_SUBSCRIPTION_DEACTIVATE_REASON:'api/List/packagedeactivationreason',
    //package-subscription ends

    // user guide
    USER_GUIDE: 'api/UserGuide/latest'

})